import LocalTranslations from "../../fr-CH/fr-CH";
import {flattenObject} from "../helpers/flatten";
export default defineI18nLocale(async locale => {
    const response = await $fetch(`/api/translations/${locale}`);
    let AllTranslations = {...flattenObject(LocalTranslations), ...response};

    //@ts-ignore
    function get(name){
        let result = (new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location?.search);
        if(result) {
            return decodeURIComponent(result[1]);
        }
    }

    if (get('lang_debug')) {
        return {};
    }

    return AllTranslations;

})